// export const upload_api = {
//   url: '',
//   title: '导入',
//   method: 'post'
// }

export const export_api = {
	url: 'supplyDownload',
	title: '导出',
	method: 'post'
}

export const list_api = {
	url: 'supplyLists',
	title: '列表',
	method: 'post'
}
export const replenishr_set_by_store = {
	url: 'getReplenishSetByStore',
	title: '单补货设置读取',
	method: 'post'
}
export const callReplenish_api = {
	url: 'callReplenish',
	title: '计算补货',
	method: 'post'
}
// export const fileHeader_api = {
//   url: '',
//   title: "",
//   method: "get"
// }

export const set_api = {
	url: 'supplySet',
	title: '设置',
	method: 'post'
}
export const selectList = [
	{
		value: 'month',
		label: '每个月',
		range: [ 1, 31 ]
	},
	{
		value: 'quarter',
		label: '每季度',
		range: [ 1, 92 ]
	},
	{
		value: 'half_year',
		label: '每半年',
		range: [ 1, 184 ]
	},
	{
		value: 'year',
		label: '每年',
		range: [ 1, 366 ]
	}
]
export function yestDate() {
	let date = new Date
	let y = date.getFullYear()
	let m = date.getMonth() + 1
	let d = date.getDate()
	return (y - 1) + '-' + (m < 10 ? ('0' + m) : m) + '-' + (d < 10 ? ('0' + d) : d)
}


// WEBPACK FOOTER //
// ./src/views/statistics/supply/desc.js